import { render, staticRenderFns } from "./quick-ranking.component.vue?vue&type=template&id=12f68909&scoped=true"
import script from "./quick-ranking.component.vue?vue&type=script&lang=ts"
export * from "./quick-ranking.component.vue?vue&type=script&lang=ts"
import style0 from "./quick-ranking.component.vue?vue&type=style&index=0&id=12f68909&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f68909",
  null
  
)

export default component.exports